/**
 * The bid fields the classic bid detail (tender-contract-dashboard-supplier) renders itself;
 * every other bid key in the owner's field registry is shown as a dynamic field.
 *
 * Exported so the v2 parity registry (app/src/app/v2/parity/parity-registry.ts) reads this
 * list from classic instead of keeping a copy (Plan 7b Ruling F-34).
 */
export const BID_DETAIL_FIELD_KEYS: readonly string[] = [
    'bid_status', 'bid_iata_service_level', 'bid_fuel_type', 'bid_index_code', 'bid_index_bate',
    'bid_index_averaging_method', 'bid_index_averaging_offset', 'bid_index_effective_day',
    'bid_market_price_value', 'bid_differential_value', 'bid_differential_currency', 'bid_differential_unit',
    'bid_payment_type', 'bid_prepayment_number_of_days_prepaid', 'bid_prepayment_payment_first_delivery',
    'bid_prepayment_payment_frequency', 'bid_payment_currency', 'bid_open_invoice_payment_terms', 'bid_open_invoice_payment_reference_date',
    'bid_open_invoice_invoice_frequency', 'bid_invoice_type', 'bid_payment_unit', 'bid_method_of_payment',
    'bid_guarantees_deposits_required', 'bid_bank_guarantee_amount', 'bid_bank_guarantee_currency', 'bid_transit_time',
    'bid_payment_exchange_financial_source', 'bid_gross_or_net_billing', 'bid_into_plane_service_provider',
    'bid_aircraft_delivery_method', 'bid_open_fuel_release', 'bid_pre_flight_notification_hours',
    'bid_ramp_limitations_notes', 'bid_fuel_availability_notes', 'location_contract_start_date', 'location_contract_end_date',
    'bid_notes', 'bid_supply_conditions_comments', 'location_iata', 'location_name', 'location_fuel_type', 'location_contract_volume', 'location_flight_type',
    'bid_fuel_availability_percentage',
    'bid_saf_mandate', 'bid_saf_mandate_blend', 'bid_neat_saf_mandated_price', 'bid_neat_saf_volume', 'bid_saf_fee_amount', 'bid_saf_fee_amount_units'
];
